import promiseRetry from 'promise-retry';

export function promiseWithRetries<T>(
  promiseFn: (params: { attempt: number }) => Promise<T>,
  {
    retries,
    onRetry,
  }: {
    retries: number;
    onRetry: (error: unknown, attempt: number) => void;
  },
): Promise<T> {
  return promiseRetry((retry, attempt) =>
    promiseFn({ attempt }).catch((error) => {
      if (attempt < retries) {
        onRetry(error, attempt);

        return retry(error);
      }

      throw error;
    }),
  );
}
